var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M24.0499 16.6668L19.9999 3.3335L15.9499 16.6668H3.33325L13.6333 24.0168L9.71659 36.6668L19.9999 28.8502L30.2999 36.6668L26.3833 24.0168L36.6666 16.6668H24.0499Z","fill":"currentColor"}})
}
var staticRenderFns = []

export { render, staticRenderFns }